export default __webpack_public_path__ + "assets/img/Bild1.2aac9e9d.jpg";